import type { RouteObject } from "react-router";

import { DASHBOARD_STRIPE_LOADER } from "@application/loaders/dashboard_stripe_loader";

export const DASHBOARD_STRIPE_ROUTE = {
  path: "stripe",
  loader: DASHBOARD_STRIPE_LOADER,
} satisfies RouteObject;
